import { STATIC_PAGE_SUCCESS, STATIC_PAGE_FAILURE } from '../actions/types';

const initialState = {
  error: null,
};

export default function staticPageReducer(state = initialState, action = {}) {
  switch (action.type) {
    case STATIC_PAGE_SUCCESS:
      return {
        ...state,
        ...action.payload.data,
      };
    case STATIC_PAGE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
